export const jumpList = state => state.list;
export const jumpCount = () => jumps => {
  if (!Array.isArray(jumps)) {
    return 0;
  }

  const count = jumps.filter(jump => jump.destination_step_id).length;

  return count;
};



/** WEBPACK FOOTER **
 ** ./src/store/modules/jump/getters.js
 **/